import { Guid } from "@/Common/Models/Guid";
import * as LocalOperations from "@/Common/Operations/operations.local";
import * as LocalPatientOperations from "@/Common/Operations/operations.patient.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { BaseOperationHandler } from "@/Common/Stores/Handlers/Local/BaseOperationHandler";

class MedicalNotePopupHandler extends BaseOperationHandler {
    constructor() {
        super();

        this.RegisterOperation(LocalPatientOperations.MedicalNote.ShowNotePopup, this.ShowNotePopup);
        this.RegisterOperation(LocalOperations.Misc.MyleApp_Container_Click, this.OnContainerClick, false);
        this.RegisterOperation(LocalPatientOperations.MedicalNote.CloseNotePopup, this.OnContainerClick);
        this.RegisterOperation(LocalPatientOperations.MedicalNote.AddEncounterNote, this.AddEncounterNote);
    }

    private ShowNotePopup(request: LocalEvent): void {
        var noteContext = request.Get<string>("noteContext");
        var event = request.Get<React.MouseEvent>("event");

        var currentPatientId = request.PatientId;
        var medicalNoteModel = patientStore.PatientMedicalNoteModels[currentPatientId];

        medicalNoteModel = medicalNoteModel.set("IsNotePopupOpen", true);
        medicalNoteModel = medicalNoteModel.set("NotePopupContext", noteContext);
        medicalNoteModel = medicalNoteModel.set("NotePopupTop", event.clientY);
        medicalNoteModel = medicalNoteModel.set("NotePopupLeft", event.clientX);

        patientStore.PatientMedicalNoteModels[currentPatientId] = medicalNoteModel;

        $(event.target).closest("tr").addClass("active");
        var a = $(".ws-footer").position().top;
        a = a - (event.clientY);

        sessionStore.showGlobalOverlay();

        $("#medicalnote_dropdown_main").css("visibility", "hidden");

        window.setTimeout(
            () => {
                $("#medicalnote_dropdown_main").removeClass("displaced");
                var h = $("#medicalnote_dropdown_main").height();
                $("#medicalnote_dropdown_main").find("textarea").focus();
                if (h > a) {
                    var t = $("#medicalnote_dropdown_main").position().top;
                    $("#medicalnote_dropdown_main").css("top", (t - h) + "px");
                    $("#medicalnote_dropdown_main").addClass("displaced");
                }
                $("#medicalnote_dropdown_main").css("visibility", "visible");
            },
            30
        );

        // store.MessageActions.LoadNotesForMessageId(item.Model.IM_ID); // this will fetch memos
    }

    private OnContainerClick(request: LocalEvent): void {
        var currentPatientId = request.PatientId;
        if (currentPatientId == null) return;
        var medicalNoteModel = patientStore.PatientMedicalNoteModels[currentPatientId];
        if (typeof medicalNoteModel !== "undefined") {
            if (medicalNoteModel.get("IsNotePopupOpen") === true) {
                medicalNoteModel = medicalNoteModel.set("IsNotePopupOpen", false);
                patientStore.PatientMedicalNoteModels[currentPatientId] = medicalNoteModel;
                $("table.myle-table tbody tr").removeClass("active");
                patientStore.EmitChangeToListeners();
                sessionStore.hideGlobalOverlay();
            }
        }
    }

    private AddEncounterNote(request: LocalEvent): void {
        var noteText = request.Get<string>("noteText");
        var context = request.Get<string>("context");
        var encounterId = request.Get<Guid>("encounterId");
        var employeeId = request.Get<Guid>("employeeContactFacerIt");

        patientStore.ActionsMedicalNote.SaveEncounterNote(encounterId, noteText, context, employeeId);
    }
}

export { MedicalNotePopupHandler };
